export const waitPlz = milliseconds => new Promise(resolve => setTimeout(resolve, milliseconds))
